<template>
  <div class="text-center">
    <h3 :class="['mt-2', errorMessage ? 'mb-4' : 'mb-8']">
      {{ $t('verification.selectMethod') }}
    </h3>
    <div v-if="errorMessage" class="mb-5 darkRed--text">
      {{ errorMessage }}
    </div>
    <v-radio-group
      v-model="verificationMethod"
      mandatory
      class="mb-2 method-select"
    >
      <v-radio
        v-if="phoneIdentifier"
        :label="$t('common.phone')"
        value="phone"
      ></v-radio>
      <v-radio
        v-if="emailIdentifier"
        :label="$t('common.email')"
        value="email"
      ></v-radio>
    </v-radio-group>
    <PrimaryButton
      :click="confirm"
      :disabled="disable || !verificationMethod"
      >{{ $t('common.confirm') }}</PrimaryButton
    >
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import PrimaryButton from '@/components/common/PrimaryButton'

export default {
  components: {
    PrimaryButton,
  },
  data() {
    return {
      verificationMethod: null,
      disable: false,
      errorMessage: null,
    }
  },
  computed: {
    ...mapState({
      emailIdentifier: 'emailIdentifier',
      phoneIdentifier: 'phoneIdentifier',
    }),
  },
  methods: {
    ...mapActions({
      requestCode: 'requestCode',
    }),
    async sendCode(codeOption) {
      try {
        this.disable = true
        await this.requestCode({
          type: codeOption,
          client_id: this.$route.query.client_id,
        })
        this.disable = false
      } catch (err) {
        this.errorMessage =
          err.response && err.response.data && err.response.data.message
            ? err.response.data.message.toString()
            : this.$t('verification.errorSending')

        this.disable = false
      }
    },
    confirm() {
      if (this.verificationMethod) {
        this.sendCode(this.verificationMethod)
      }
    },
  },
}
</script>
<style lang="sass">
.method-select
  .v-radio
    padding: 6px 12px
    background-color: $white
    &:not(:last-child):not(:only-child)
      margin-bottom: 24px
    &.v-item--active
      .v-label
        color: $darkBlue
</style>
